import { IGroupAmssador } from './GroupAmbassador.interface';

export const initialState: IGroupAmssador = {
  groups: [],
  ambassador: []
};
